export default "__VITE_ASSET__$HLm56wM__"